import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function CmvPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="dashboard"
      subsectionPath="cmv"
    />
  );
}
